import { useEffect, useRef } from 'react';

export function useWindowEvent<Type extends keyof WindowEventMap>(
  type: Type,
  listener: (this: Window, ev: WindowEventMap[Type]) => any,
  options?: boolean | AddEventListenerOptions
) {
  const listenerRef = useRef(listener);
  listenerRef.current = listener;

  useEffect(() => {
    function handler(event: WindowEventMap[Type]) {
      listenerRef.current.call(window, event);
    }

    window.addEventListener(type, handler, options);
    return () => window.removeEventListener(type, handler, options);
  }, [type, options]);
}
